/* eslint-disable import/prefer-default-export */

export const getmanagementGroupIndexes = (
  userData,
  type = "user",
  roleData = null,
) => {
  let uniqueList = [];
  const returnElem = {};
  let not_allowed_project_list = [];

  if (userData?.hotels) {
    uniqueList = setHMG(userData);
  } else if (userData?.data) {
    userData.data.forEach((hmg) => {
      uniqueList = setHMG(hmg);
    });
  }

  if (
    userData?.custom_permission &&
    userData?.custom_permission_data?.project_permissions &&
    Array.isArray(
      userData?.custom_permission_data?.project_permissions
        ?.not_allowed_project_list,
    )
  ) {
    not_allowed_project_list =
      userData.custom_permission_data.project_permissions
        .not_allowed_project_list;
  } else if (type === "role") {
    if (
      roleData?.role_data?.project_permissions !== undefined &&
      Array.isArray(
        roleData?.role_data.project_permissions.not_allowed_project_list,
      )
    ) {
      not_allowed_project_list =
        roleData.role_data.project_permissions.not_allowed_project_list;
    }
  }

  uniqueList.forEach((elem) => {
    if (Array.isArray(elem.indexes)) {
      elem.indexes.forEach((relem, rindex) => {
        let userAccess = false;
        if (userData?.custom_permission &&
          userData?.custom_permission_data?.index_permissions) {
          const userElem =
            userData?.custom_permission_data?.index_permissions?.permission_list?.find(
              (ulm) =>
                ulm.hmg_id === elem._id && ulm.index_id === relem.index_id._id,
            );
          userAccess =
            userElem !== undefined && userElem.value !== undefined
              ? userElem.value
              : false;
        } else if (type === "role") {
          if (roleData?.role_data?.index_permissions) {
            const userElem =
              roleData.role_data.index_permissions?.permission_list?.find(
                (ulm) =>
                  ulm.hmg_id === elem._id &&
                  ulm.index_id === relem.index_id._id,
              );
            userAccess =
              userElem !== undefined && userElem.value !== undefined
                ? userElem.value
                : true;
          } else {
            userAccess = true;
          }
        }
        returnElem[`index_${elem._id}_${relem.index_id._id}`] = userAccess;
      });
    }
  });
  return {
    not_allowed_project_list,
    indexList: uniqueList,
    indexPermissions: returnElem,
    indexEnabled:
      userData?.custom_permission ?
      userData?.custom_permission_data?.index_permissions?.index_permission_access: 
      roleData?.role_data?.index_permissions?.index_permission_access
  };
};

function setHMG(data) {
  const uniqueList = [];
  data.hotels.forEach((elem) => {
    if (
      elem.primary_hmg_id !== undefined &&
      elem.primary_hmg_id !== null &&
      uniqueList.findIndex((uelem) => uelem._id == elem.primary_hmg_id._id) ===
        -1
    ) {
      uniqueList.push(elem.primary_hmg_id);
    }

    if (
      elem.secondary_hmg_id !== undefined &&
      elem.secondary_hmg_id !== null &&
      uniqueList.findIndex(
        (uelem) => uelem._id == elem.secondary_hmg_id._id,
      ) === -1
    ) {
      uniqueList.push(elem.secondary_hmg_id);
    }

    if (
      elem.third_hmg_id !== undefined &&
      elem.third_hmg_id !== null &&
      uniqueList.findIndex((uelem) => uelem._id == elem.third_hmg_id._id) === -1
    ) {
      uniqueList.push(elem.third_hmg_id);
    }

    if (
      elem.fourth_hmg_id !== undefined &&
      elem.fourth_hmg_id !== null &&
      uniqueList.findIndex((uelem) => uelem._id == elem.fourth_hmg_id._id) ===
        -1
    ) {
      uniqueList.push(elem.fourth_hmg_id);
    }
  });
  return uniqueList;
}